var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-container',[_c('ui-row',{attrs:{"align-h":"center"}},[_c('ui-col',{attrs:{"lg":10}},[(_vm.eventName)?_c('article-list',{staticClass:"event-article-list",attrs:{"from":"book","event-name":_vm.eventName}}):_vm._e()],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }